import AWS from './logo/aws.png';
import AWSDark from './logo/aws-dark.png';
import Azure from './logo/azure.png';
import GCP from './logo/gcp.png';
import K8S from './logo/kubernetes.png';
import { Tooltip } from '../tooltip';
import { generatePublicImagePath } from '../static-image/generatePublicImagePath';
import { CODE_PROVIDERS } from '../../constants/code-provider';

const isDark = () => document.documentElement.classList.contains('dark');

export type ProviderImageProps = {
  /**
   * a node to be rendered in the special component.
   */
  provider?: string;
  img?: string;
  className?: string;
  imgClass?: string;
  sizeClassName?: string;
  tooltip?: boolean;
  lowerAWS?: boolean;
};

export const getProviderImage = (provider?: string, dark?: boolean) => {
  switch (provider) {
    case 'aws':
      return dark ? AWSDark : AWS;
    case 'azure':
      return Azure;
    case 'gcp':
      return GCP;
    case 'kubernetes':
      return K8S;
  }
};

const CODE_PROVIDER_NAMES = CODE_PROVIDERS.map((name) => name.toLowerCase());

// Code providers' logos are served from static content, as Image shows them.
const getPublicProviderImage = (provider?: string, dark?: boolean) => {
  if (provider && CODE_PROVIDER_NAMES.includes(provider)) {
    return generatePublicImagePath({ type: 'provider', name: provider, dark });
  }
};

export function ProviderImage({
  provider,
  img,
  className = ' shadow-br-primary/25',
  imgClass = '',
  sizeClassName,
  tooltip,
  lowerAWS = true,
}: ProviderImageProps) {
  const lowerProvider = provider?.toLowerCase();
  const dark = isDark();
  const src =
    img ||
    getProviderImage(lowerProvider, dark) ||
    getPublicProviderImage(lowerProvider, dark);
  const elem = src && (
    <div
      className={`inline-flex ${
        lowerProvider === 'aws' && lowerAWS ? 'items-end' : 'items-center'
      } ${sizeClassName ? sizeClassName : 'h-12 w-12'} ${className} ${
        lowerProvider === 'aws' ? 'p-1' : 'p-[6px]'
      }`}
    >
      <img src={src} className={`w-full object-cover ${imgClass}`} />
    </div>
  );
  return tooltip ? (
    <Tooltip label={provider || ''}>{elem ? elem : <></>}</Tooltip>
  ) : elem ? (
    elem
  ) : (
    <></>
  );
}
